import { CompletionRoutes, TestCompletionRoutes } from "@/enums/routes/CompletionRoutes.ts";
import { ExpeditionRoutes, TestExpeditionRoutes } from "@/enums/routes/ExpeditionRoutes.ts";
import { PalletCheckerRoutes, TestPalletCheckerRoutes } from "@/enums/routes/PalletCheckerRoutes";
import { PickingRoutes, TestPickingRoutes } from "@/enums/routes/PickingRoutes.ts";
import router from "@/router";
import type { App } from "@/stores/AppStore";

const RouteNames = {
    picking: [PickingRoutes, TestPickingRoutes],
    completion: [CompletionRoutes, TestCompletionRoutes],
    expedition: [ExpeditionRoutes, TestExpeditionRoutes],
    palletChecker: [PalletCheckerRoutes, TestPalletCheckerRoutes],
};

export async function goToRoute<A extends App>(
    app: A,
    name: keyof (typeof RouteNames)[A][number],
    params = {},
): Promise<void> {
    const appsMode = localStorage.getItem("appsMode") || "production";
    const routeNames = appsMode === "production" ? RouteNames[app][0] : RouteNames[app][1];
    await router.push({ name: routeNames[name as keyof typeof routeNames], params });
}
